var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLetterdeco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 72,
    viewBox: "0 0 70 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5368 17.3288C9.50405 23.676 7 30.9169 7 35.1241C7 37.0571 5.433 38.6241 3.5 38.6241C1.567 38.6241 0 37.0571 0 35.1241C0 29.0374 3.24998 20.4663 7.62847 13.5749C9.85765 10.0664 12.5154 6.77132 15.4435 4.31309C18.3278 1.89167 21.8181 0 25.6368 0C27.5698 0 29.1368 1.567 29.1368 3.5C29.1368 5.433 27.5698 7 25.6368 7C24.1412 7 22.2072 7.77461 19.9444 9.67429C17.7254 11.5372 15.5132 14.2181 13.5368 17.3288ZM38.0275 40.2355C31.1517 44.2804 24.6246 49.2913 19.938 53.0991C18.4378 54.3181 16.2335 54.09 15.0146 52.5898C13.7956 51.0896 14.0237 48.8853 15.5239 47.6663C20.3096 43.7779 27.1537 38.511 34.4781 34.2021C41.6786 29.9661 49.8799 26.3271 57.261 26.3271C59.194 26.3271 60.761 27.8941 60.761 29.8271C60.761 31.7601 59.194 33.3271 57.261 33.3271C51.8546 33.3271 45.027 36.1178 38.0275 40.2355ZM25.8634 71.0796C39.7388 67.0623 51.2658 66.3108 65.0914 69.655C66.9702 70.1094 68.8617 68.9547 69.3162 67.0759C69.7706 65.1971 68.616 63.3056 66.7371 62.8512C51.5415 59.1756 38.7635 60.0572 23.9166 64.3558C22.0599 64.8934 20.9905 66.8344 21.5281 68.6911C22.0657 70.5478 24.0066 71.6172 25.8634 71.0796Z",
    fill: "#46777A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterdeco);
export default __webpack_public_path__ + "static/media/letterdeco.e4df317bbb6fcde096ba6b1746b4a93b.svg";
export { ForwardRef as ReactComponent };